<div class="content-block">

  <!-- Content Header (Page header) -->

  <div class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          <h1 class="m-0 text-dark">Documento consegna Articolo</h1>
        </div><!-- /.col -->
        @if(!isBase){
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
            <li class="breadcrumb-item">Magazzino</li>
            <li class="breadcrumb-item active"><a href="/movimenti-articoli/false">Da firmare</a></li>
          </ol>
        </div><!-- /.col -->
        }
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->


  <section class="col-lg-12 ">

    <div class="card primary">

      <div class="card-body">
        <div class="content-block">
          @if (!amWaiting) {
          <div class="row">
            @if (pdfSrc != undefined) {
            <div class="row col-10" >
              <ngx-extended-pdf-viewer #pdfViewer [src]="pdfSrc" 
                [showToolbar]="false"
                [height]="'73vh'"
                [showPageCorners]="true">
              </ngx-extended-pdf-viewer>
            </div>
            }
            <div class="col-2">
              <div class="div-buttons">
                @if(isBase){
                <dx-button stylingMode="contained" type="normal" class="dx-button-orange" text="Torna alla dashboard"
                  (click)="goToDashboardBase()"></dx-button>
                }
                @else{
                <dx-button stylingMode="contained" type="normal" class="dx-button-orange" text="Torna ai Movimenti"
                  (click)="goToMovimenti()"></dx-button>
                }
                <!-- <button  type="button" class="btn btn-link" (click)="goToMovimenti();" style="margin-left:15px;color: rgb(255, 94, 0); ">Torna ai movimenti</button> -->
                @if (showVisualizzaPDF) {
                <dx-button stylingMode="contained" type="normal" class="dx-button-orange" text="Stampa PDF"
                  (click)="visualizzaPDF()"></dx-button>
                }
                @if (showVisualizzaPDF) {
                <dx-button stylingMode="contained" type="normal" class="dx-button-orange" (click)="scaricaPDF();"
                  text="Scarica PDF"></dx-button>
                }
                @if (!movimento?.firmato) {
                <dx-button stylingMode="contained" type="normal" class="dx-button-orange"
                  (click)="visualizzaPDFPerFirma();" text="Stampa da firmare"></dx-button>
                }
              </div>
              @if (!movimento?.firmato) {
              <div class="row" style="margin-top: 10px;">
                <div class="div-check">
                  <dx-check-box [(value)]="checkInviaMail"></dx-check-box>
                  <div class="dx-field-label">
                    Invia mail
                  </div>
                </div>
              </div>
              <div class="div-buttons">
                <dx-button stylingMode="contained" text="Firma e salva" type="normal" class="dx-button-orange"
                  (onClick)="showFirmaDoc()">
                </dx-button>
                @if (tempFirmaEseguita) {
                <dx-button stylingMode="contained" text="Conferma" type="normal" class="dx-button-orange"
                  (onClick)="confermaFirma()">
                </dx-button>
                }
                @if (!uploadingFileFirmato) {
                <dx-button stylingMode="contained" text="Allega file firmato" type="normal" class="dx-button-orange"
                  (onClick)="preparaAllegaFileFirmato()">
                </dx-button>
                }
              </div>

              }
              @if (uploadingFileFirmato) {
              <div class="row">
                <form>
                  <div class="col-6 col-md-4">
                    <div class="widget-container">
                      <div class="dx-fieldset-header">File</div>
                      <dx-file-uploader #fileUploader [multiple]="false" accept="*" [(value)]="uploadingFileValue"
                        uploadMode="useForm" (onValueChanged)="onFileUploaded($event)">
                        <dx-validator>
                          <dxi-validation-rule type="required" message="Selezionare il file"></dxi-validation-rule>
                        </dx-validator>
                      </dx-file-uploader>
                    </div>
                  </div>
                </form>
                <dx-button stylingMode="contained" text="Allega" type="normal" width="120" type="success"
                  (onClick)="allegaFileFirmato($event, fileUploader.value)" style="margin-left: 15px;">
                </dx-button>
              </div>
              }
            </div>
          </div>
          }
        </div>
        @if (amWaiting) {
        <div class="row">
          <div class="col-xl-2 col-sm-2 col-xs-4 offset-xl-5 offset-md-5 offset-xs-4">
            <dx-load-indicator id="large-indicator" height="60" width="60"></dx-load-indicator>
          </div>
        </div>
        }


      </div><!-- /.card-body -->
      <div class="card-footer">

      </div>
    </div>
    <!-- /.card -->

  </section>



</div>



<dx-popup [fullScreen]="true" [showTitle]="true" title="Firma" [dragEnabled]="false" [hideOnOutsideClick]="true"
  [(visible)]="divFirmaVisible">
  <div id="signature"
    style="background:#ffffff; color:#000000; border-style: groove; border-color: #777777; width: 100%; height: 80%;">
  </div>

  <div class="row">
    <div class="col-4 offset-8 col-md-4">
      <dx-button stylingMode="contained" text="Ripeti" type="normal" width="120" (onClick)="ripetiFirma()">
      </dx-button>
      <dx-button stylingMode="contained" text="Ok" type="success" width="120" (onClick)="firmaMovimento()">
      </dx-button>
    </div>
  </div>
</dx-popup>

@if (popupWarning) {
<dx-popup [width]="550" [height]="280" [showTitle]="true" [dragEnabled]="false"
  [hideOnOutsideClick]="true" [showCloseButton]="true" [(visible)]="popupWarning">

  <div class="warning-popup">
    <i class="dx-icon-warning warning-icon"></i>

    <div class="warning-text">
      <h3>Documento non firmato</h3>
      <p>
        Se non viene apposta la firma, la consegna
        <strong>non risulterà effettuata</strong> nel sistema.
      </p>
    </div>

    <div class="warning-actions">
      <dx-button text="Ho capito" type="default" stylingMode="contained" class="dx-button-orange" (onClick)="popupWarning = false">
      </dx-button>
    </div>
  </div>
</dx-popup>
}

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadPanelVisible" [showIndicator]="true"
  [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
</dx-load-panel>